/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import PropTypes from 'prop-types';

const ReportIcon = ({ color, width, height }) => {
  return (
    <svg
      css={css`
        fill: ${color || '#5CB3DB'};
        max-width: ${width || '30'}px;
        max-height: ${height || '30'}px;
        height: ${height || '30'}px;
        width: ${width || '30'}px;
      `}
    >
      <g id="surface1">
        <path
          style={{
            stroke: '#none',
            fillRule: 'nonzero',
            fillOpacity: 1,
          }}
          d="M 9 1.875 C 8.378906 1.875 7.875 2.378906 7.875 3 C 7.875 3.621094 8.378906 4.125 9 4.125 C 9.621094 4.125 10.125 3.621094 10.125 3 C 10.125 2.378906 9.621094 1.875 9 1.875 Z M 9 3.375 C 8.792969 3.375 8.625 3.207031 8.625 3 C 8.625 2.792969 8.792969 2.625 9 2.625 C 9.207031 2.625 9.375 2.792969 9.375 3 C 9.375 3.207031 9.207031 3.375 9 3.375 Z M 9 3.375 "
        />
        <path
          style={{
            stroke: '#none',
            fillRule: 'nonzero',
            fillOpacity: 1,
          }}
          d="M 4.125 12.375 L 5.625 12.375 L 5.625 13.125 L 4.125 13.125 Z M 4.125 12.375 "
        />
        <path
          style={{
            stroke: '#none',
            fillRule: 'nonzero',
            fillOpacity: 1,
          }}
          d="M 6.375 12.375 L 12 12.375 L 12 13.125 L 6.375 13.125 Z M 6.375 12.375 "
        />
        <path
          style={{
            stroke: '#none',
            fillRule: 'nonzero',
            fillOpacity: 1,
          }}
          d="M 4.125 14.625 L 5.625 14.625 L 5.625 15.375 L 4.125 15.375 Z M 4.125 14.625 "
        />
        <path
          style={{
            stroke: '#none',
            fillRule: 'nonzero',
            fillOpacity: 1,
          }}
          d="M 4.125 16.875 L 5.625 16.875 L 5.625 17.625 L 4.125 17.625 Z M 4.125 16.875 "
        />
        <path
          style={{
            stroke: '#none',
            fillRule: 'nonzero',
            fillOpacity: 1,
          }}
          d="M 4.125 19.125 L 5.625 19.125 L 5.625 19.875 L 4.125 19.875 Z M 4.125 19.125 "
        />
        <path
          style={{
            stroke: '#none',
            fillRule: 'nonzero',
            fillOpacity: 1,
          }}
          d="M 22.875 13.125 L 22.5 13.125 C 21.285156 13.121094 20.101562 12.726562 19.125 12 L 18.226562 11.324219 C 18.09375 11.222656 17.90625 11.222656 17.773438 11.324219 L 17.25 11.71875 L 17.25 4.125 C 17.25 3.503906 16.746094 3 16.125 3 L 13.058594 3 C 12.898438 2.550781 12.476562 2.253906 12 2.25 L 11.121094 2.25 C 10.804688 1.347656 9.953125 0.746094 9 0.746094 C 8.046875 0.746094 7.195312 1.347656 6.878906 2.25 L 6 2.25 C 5.523438 2.253906 5.101562 2.550781 4.941406 3 L 1.875 3 C 1.253906 3 0.75 3.503906 0.75 4.125 L 0.75 22.125 C 0.75 22.746094 1.253906 23.25 1.875 23.25 L 16.125 23.25 C 16.46875 23.246094 16.792969 23.089844 17.007812 22.820312 L 17.839844 23.210938 C 17.941406 23.261719 18.058594 23.261719 18.160156 23.210938 L 21.453125 21.648438 C 22.5625 21.066406 23.253906 19.917969 23.25 18.667969 L 23.25 13.5 C 23.25 13.292969 23.082031 13.125 22.875 13.125 Z M 13.125 3.75 L 16.125 3.75 C 16.332031 3.75 16.5 3.917969 16.5 4.125 L 16.5 12.257812 C 16.261719 12.410156 16.007812 12.539062 15.75 12.652344 L 15.75 4.875 C 15.75 4.667969 15.582031 4.5 15.375 4.5 L 13.125 4.5 Z M 5.625 3.375 C 5.625 3.167969 5.792969 3 6 3 L 7.164062 3 C 7.339844 3 7.496094 2.875 7.53125 2.699219 C 7.671875 2 8.285156 1.5 9 1.5 C 9.714844 1.5 10.328125 2 10.46875 2.699219 C 10.503906 2.875 10.660156 3 10.835938 3 L 12 3 C 12.207031 3 12.375 3.167969 12.375 3.375 L 12.375 4.875 L 5.625 4.875 Z M 5.25 5.625 L 12.75 5.625 C 12.957031 5.625 13.125 5.457031 13.125 5.25 L 15 5.25 L 15 12.914062 C 14.511719 13.050781 14.007812 13.121094 13.5 13.125 L 13.125 13.125 C 12.917969 13.125 12.75 13.292969 12.75 13.5 L 12.75 14.625 L 6.375 14.625 L 6.375 15.375 L 12.75 15.375 L 12.75 16.875 L 6.375 16.875 L 6.375 17.625 L 12.75 17.625 L 12.75 18.667969 C 12.75 18.820312 12.761719 18.972656 12.78125 19.125 L 6.375 19.125 L 6.375 19.875 L 12.980469 19.875 C 13.140625 20.292969 13.382812 20.675781 13.695312 21 L 3 21 L 3 5.25 L 4.875 5.25 C 4.875 5.457031 5.042969 5.625 5.25 5.625 Z M 16.125 22.5 L 1.875 22.5 C 1.667969 22.5 1.5 22.332031 1.5 22.125 L 1.5 4.125 C 1.5 3.917969 1.667969 3.75 1.875 3.75 L 4.875 3.75 L 4.875 4.5 L 2.625 4.5 C 2.417969 4.5 2.25 4.667969 2.25 4.875 L 2.25 21.375 C 2.25 21.582031 2.417969 21.75 2.625 21.75 L 14.761719 21.75 L 16.265625 22.464844 C 16.222656 22.488281 16.175781 22.5 16.125 22.5 Z M 22.5 18.667969 C 22.503906 19.632812 21.96875 20.523438 21.117188 20.976562 L 18 22.457031 L 14.890625 20.980469 C 14.035156 20.527344 13.5 19.636719 13.5 18.667969 L 13.5 13.875 C 14.878906 13.871094 16.21875 13.425781 17.324219 12.601562 L 18 12.09375 L 18.675781 12.601562 C 19.78125 13.425781 21.121094 13.871094 22.5 13.875 Z M 22.5 18.667969 "
        />
        <path
          style={{
            stroke: '#none',
            fillRule: 'nonzero',
            fillOpacity: 1,
          }}
          d="M 11.25 7.875 L 10.125 7.875 L 10.125 6.75 C 10.125 6.542969 9.957031 6.375 9.75 6.375 L 8.25 6.375 C 8.042969 6.375 7.875 6.542969 7.875 6.75 L 7.875 7.875 L 6.75 7.875 C 6.542969 7.875 6.375 8.042969 6.375 8.25 L 6.375 9.75 C 6.375 9.957031 6.542969 10.125 6.75 10.125 L 7.875 10.125 L 7.875 11.25 C 7.875 11.457031 8.042969 11.625 8.25 11.625 L 9.75 11.625 C 9.957031 11.625 10.125 11.457031 10.125 11.25 L 10.125 10.125 L 11.25 10.125 C 11.457031 10.125 11.625 9.957031 11.625 9.75 L 11.625 8.25 C 11.625 8.042969 11.457031 7.875 11.25 7.875 Z M 10.875 9.375 L 9.75 9.375 C 9.542969 9.375 9.375 9.542969 9.375 9.75 L 9.375 10.875 L 8.625 10.875 L 8.625 9.75 C 8.625 9.542969 8.457031 9.375 8.25 9.375 L 7.125 9.375 L 7.125 8.625 L 8.25 8.625 C 8.457031 8.625 8.625 8.457031 8.625 8.25 L 8.625 7.125 L 9.375 7.125 L 9.375 8.25 C 9.375 8.457031 9.542969 8.625 9.75 8.625 L 10.875 8.625 Z M 10.875 9.375 "
        />
        <path
          style={{
            stroke: '#none',
            fillRule: 'nonzero',
            fillOpacity: 1,
          }}
          d="M 21.429688 14.542969 C 20.269531 14.367188 19.167969 13.90625 18.226562 13.199219 C 18.09375 13.097656 17.90625 13.097656 17.773438 13.199219 C 16.832031 13.90625 15.730469 14.367188 14.570312 14.542969 C 14.386719 14.570312 14.25 14.730469 14.25 14.914062 L 14.25 18.667969 C 14.25 19.347656 14.621094 19.976562 15.21875 20.304688 L 15.238281 20.316406 L 17.839844 21.550781 C 17.941406 21.601562 18.058594 21.601562 18.160156 21.550781 L 20.78125 20.304688 C 21.378906 19.976562 21.75 19.347656 21.75 18.667969 L 21.75 14.914062 C 21.75 14.730469 21.613281 14.570312 21.429688 14.542969 Z M 21 18.667969 C 21.003906 19.070312 20.785156 19.441406 20.4375 19.640625 L 18 20.796875 L 15.570312 19.644531 C 15.21875 19.445312 15 19.074219 15 18.667969 L 15 15.230469 C 16.078125 15.019531 17.097656 14.585938 18 13.960938 C 18.902344 14.585938 19.921875 15.019531 21 15.230469 Z M 21 18.667969 "
        />
        <path
          style={{
            stroke: '#none',
            fillRule: 'nonzero',
            fillOpacity: 1,
          }}
          d="M 16.390625 17.734375 L 15.859375 18.265625 L 16.984375 19.390625 C 17.132812 19.535156 17.367188 19.535156 17.515625 19.390625 L 20.515625 16.390625 L 19.984375 15.859375 L 17.25 18.59375 Z M 16.390625 17.734375 "
        />
      </g>
    </svg>
  );
};

export default ReportIcon;

ReportIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};
